import { Button } from '../ui/button'
import { SmsIcon } from './icons'
import { Input } from '../ui/input'
export function AffiliateProgramBanner() {
	return (
		<div className='relative flex flex-col-reverse gap-8 overflow-hidden rounded-[14px] border border-border bg-secondary p-6 sm:p-12 lg:flex-row lg:items-center'>
			<div className='pointer-events-none absolute -left-32 -top-24 h-[500px] w-[500px] rounded-full opacity-60 blur-[140px]' style={{ background: 'hsl(var(--info))' }} />

			<img src='/images/affiliate/affiliate_subscription.png' alt='' className='pointer-events-none absolute left-0 top-12 z-0 hidden h-full object-contain sm:block' />

			<div className='relative z-10 flex flex-1 items-center justify-center'></div>

			<div className='relative z-10 flex flex-1 flex-col gap-8'>
				<div className='flex flex-col gap-4'>
					<h2 className='text-2xl font-extrabold leading-[136%] tracking-[-0.16px] sm:text-[32px]'>
						<span className='text-foreground'>Learn more about our</span>
						<br />
						<span className='bg-gradient-to-r from-[hsl(var(--accent-blue))] to-[hsl(var(--accent-green))] bg-clip-text text-transparent'>Affiliate program</span>
					</h2>
					<p className='text-base leading-[140%] tracking-[-0.24px] text-muted-foreground'>
						If you have a large audience and followers. We have special conditions for you to customize your referral program! If you can invite players and their wager
						amount reaches a billion dollars and above, you will get your own customized casino! You can set up a casino website with your domain and design style. For
						more details, please contact US.
					</p>
				</div>

				<div className='flex flex-col items-stretch gap-4 sm:flex-row sm:items-start'>
					<Input variant='icon' icon={<SmsIcon />} placeholder='example@gmail.com' type='email' containerClassName='flex-1' />
					<Button variant='primary'>Send Now</Button>
				</div>
			</div>
		</div>
	)
}
